import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper"; 
import "../styles/slide1.css";

// Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// BioSurge Images 
import bioImg1 from "../assets/images/slide1.png"; 
import bioImg2 from "../assets/images/slide2.png"; 
import bioImg3 from "../assets/images/slide3.png";

const Slide = () => {
  const navigate = useNavigate(); 
  const handleOrderNow = () => {
    navigate("/all-products"); 
  };
 const slideData = [
  {
    id: 1,
    title: "Unleash Natural Energy",
    subTitle: "Traditional Ayurvedic Majun",
    desc: "Crafted with time-tested Ayurvedic herbs to support daily energy, stamina, and overall vitality in a natural way.",
    img: bioImg1,
  },
  {
    id: 2,
    title: "Confidence in Everyday Performance",
    subTitle: "Consistent Wellness Support",
    desc: "A balanced herbal blend designed to help maintain stamina, reduce fatigue, and keep you feeling active and confident.",
    img: bioImg2,
  },
  {
    id: 3,
    title: "Herbal Strength & Vitality",
    subTitle: "Pure Honey-Based Formula",
    desc: "Made with honey and powerful botanicals like Ashwagandha, Safed Musli, and Akarkara to support strength and holistic wellbeing.",
    img: bioImg3,
  },
];

  return (
    <section className="banner-slider-wrapper">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop={true}
        className="mySwiper"
      >
        {slideData.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="slide-container">
              <div className="slide-content">
                <h2 className="slide-title">
                  {slide.title} <br />
                  <span className="neon-text">{slide.subTitle}</span>
                </h2>
                <p className="slide-desc">{slide.desc}</p>
                <button onClick={handleOrderNow} className="biosurge-btn">Order Now & Feel the Difference</button>
              </div>

              <div className="slide-image-box">
                <img src={slide.img} alt="BioSurge Product" className="floating-img" />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Slide;